import { FlexProps } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import { getCurrentQuote } from '../../../domain'
import { useEditProposal } from '../../../hooks/proposal'
import { ProductKind } from '../../../state/configuration'
import { toDateTime } from '../../../util/date'
import { useProduct } from '../../product/ProductProvider'
import { useProposal } from '../../product/proposal/ProposalProvider'
import { QuoteDetails } from '../quote'

export const ProposalDetailsView: FunctionComponent<FlexProps> = (props) => {
  const { product } = useProduct()
  const { proposal } = useProposal()

  const quote = getCurrentQuote(proposal)
  const handleEdit = useEditProposal(proposal)

  const startAt = toDateTime(proposal.startAt)
  const endAt =
    product.productKind === ProductKind.SUBSCRIPTION
      ? undefined
      : toDateTime(proposal.endAt)

  return (
    <QuoteDetails
      onEdit={handleEdit}
      quote={quote}
      startAt={startAt}
      endAt={endAt}
      {...props}
    />
  )
}
